<template>
    <el-button v-bind="$attrs" :style="style"><slot></slot></el-button>
</template>

<script setup name="kr-button">
import { computed } from "vue";
import { ElButton } from "element-plus";

const props = defineProps({
    fontSize: {
        type: [Number, String],
        default: "",
    },
});

const style = computed(() => {
    if (!props.fontSize) return {};
    return {
        "font-size": props.fontSize + "px",
    };
});
</script>
